import { feature as sessionServiceFeature } from '@central-products/session-service';

export const sessionServicePlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(sessionServiceFeature);
  },
};
